import ErrorCard from "Components/errorCards/ErrorCard/ErrorCard";
import ErrorCardButton from "Components/errorCards/ErrorCard/ErrorCardButton/ErrorCardButton";
import ErrorCardFinePrint from "Components/errorCards/ErrorCard/ErrorCardFinePrint/ErrorCardFinePrint";
import { ButtonStyle } from "lexus-style-guide/buttons/shared";
import { FC } from "react";

interface Prop {
    message: string;
    onClick: () => void;
}

const UpdateConfirmationCard: FC<Prop> = ({ message, onClick }) => {
    return (
        <ErrorCard title={"update the encore app"} className={"is-bg-type-light"}>
            <ErrorCardFinePrint>{message}</ErrorCardFinePrint>
            <ErrorCardButton onClick={onClick} buttonStyle={ButtonStyle.Primary}>
                Update now
            </ErrorCardButton>
        </ErrorCard>
    );
};

export default UpdateConfirmationCard;
